import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueAnalytics from "vue-analytics";
import store from "./store";
import Vuesax from "vuesax";
import "boxicons";

import "vuesax/dist/vuesax.css";
import "boxicons/css/boxicons.min.css";

Vue.use(Vuesax, {
  colors: {
    primary: '#ff1f35',
    success: 'rgb(23, 201, 100)',
    danger: 'rgb(242, 19, 93)',
    warning: 'rgb(255, 130, 0)',
    dark: 'rgb(36, 33, 69)',
  },
})

Vue.use(VueAnalytics, {
  id: 'UA-154471808-1',
  linkers: ['kuntokeskuscrossgym.fi', 'crossgym.lataaopas.fi'],
  router,
})

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
